export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="bg-gradient-to-br from-accent-100/60 via-background-100 to-primary-100/40 rounded-2xl border border-background-200/60 overflow-hidden">
          <div className="flex flex-col lg:flex-row items-center gap-8 p-6 md:p-10">
            <div className="flex-1 text-center lg:text-left">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
                随时随地追番
              </h2>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6 max-w-md mx-auto lg:mx-0">
                91樱花支持手机、平板、电脑多端访问。无需下载APP，打开浏览器即可畅享高清动漫，随时随地满足你的追番需求。
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
                <div className="flex items-center gap-2 px-5 py-3 bg-background-50 rounded-xl border border-background-200/60 cursor-pointer">
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-smartphone-line text-accent-600 text-lg"></i>
                  </div>
                  <span className="text-sm font-medium text-foreground-800 whitespace-nowrap">手机浏览器访问</span>
                </div>
                <div className="flex items-center gap-2 px-5 py-3 bg-background-50 rounded-xl border border-background-200/60 cursor-pointer">
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-computer-line text-primary-600 text-lg"></i>
                  </div>
                  <span className="text-sm font-medium text-foreground-800 whitespace-nowrap">电脑端访问</span>
                </div>
              </div>
            </div>
            <div className="flex-1 flex justify-center">
              <div className="relative w-52 h-[320px] rounded-2xl overflow-hidden border-4 border-background-200/60 bg-background-100">
                <img
                  src="https://readdy.ai/api/search-image?query=Mobile%20phone%20mockup%20showing%20anime%20streaming%20app%20interface%20with%20cherry%20blossom%20theme%2C%20warm%20pink%20and%20cream%20colors%2C%20anime%20artwork%20thumbnails%20displayed%20in%20a%20clean%20grid%20layout%2C%20modern%20minimalist%20UI%2C%20elegant%20Japanese%20aesthetic%2C%20soft%20lighting%2C%20high%20quality%20app%20screen%20design&width=600&height=1000&seq=app-mockup-sakura&orientation=portrait"
                  alt="91樱花移动端追番体验"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}